/** Dedup em memória para postLog Tipo=Erro — espelha janela do mobile (30s). */

const DEDUPE_MS = 30_000;
const MAX_KEYS = 200;
const recent = new Map<string, number>();

export function buildErrorLogDedupeKey(parts: {
  message?: string | null;
  name?: string | null;
  route?: string | null;
  status?: number | string | null;
  origem?: string | null;
}): string {
  return [
    parts.message ?? "",
    parts.name ?? "",
    parts.route ?? "",
    parts.status ?? "",
    parts.origem ?? "",
  ].join("|");
}

/**
 * @returns true se este log deve ser pulado (já enviado na janela).
 */
export function shouldSkipDuplicateErrorLog(key: string): boolean {
  if (!key.trim()) return false;
  const now = Date.now();
  const last = recent.get(key);
  if (last != null && now - last < DEDUPE_MS) return true;
  recent.set(key, now);
  if (recent.size > MAX_KEYS) {
    for (const [k, ts] of recent) {
      if (now - ts > DEDUPE_MS) recent.delete(k);
    }
  }
  return false;
}
